import * as React from 'react';
import { createComponent } from '@lit/react';
import {
  GenerateComponentTypeWithChildren,
  GeneratePropsWithRef,
} from '../component-types-generics';
import { AccordionItemWC } from './accordion-item.wc';

export type AccordionItemProps =
  GenerateComponentTypeWithChildren<AccordionItemWC> & {
    onShow?: React.MouseEventHandler<AccordionItemWC>;
    onAfterShow?: React.MouseEventHandler<AccordionItemWC>;
    onHide?: React.MouseEventHandler<AccordionItemWC>;
    onAfterHide?: React.MouseEventHandler<AccordionItemWC>;
    onHeaderClick?: React.MouseEventHandler<AccordionItemWC>;
  };

export type AccordionItemPropsWithRef =
  GeneratePropsWithRef<AccordionItemProps>;

export const AccordionItem = createComponent({
  tagName: AccordionItemWC.tagname,
  elementClass: AccordionItemWC,
  react: React,
  events: {
    onShow: 'ps-show',
    onAfterShow: 'ps-after-show',
    onHide: 'ps-hide',
    onAfterHide: 'ps-after-hide',
    onHeaderClick: 'ps-header-click',
  },
}) as AccordionItemPropsWithRef;
